import React, { useContext, useEffect, useState, useCallback, useRef } from 'react'
import { FullScreen } from 'ol/control'
import MapContext from "../Map/MapContext"
import GeoJSON from 'ol/format/GeoJSON';

import { defaultLineCap } from 'ol/render/canvas'
import Draw, {
    createBox,
    createRegularPolygon,
} from 'ol/interaction/Draw';

import Select from 'ol/interaction/Select';


import styled from 'styled-components'
import get from 'lodash/get'
import { injectIntl } from 'react-intl'

const ToolbarWrapper = styled.div`
    position:relative;
    z-index:1;
    margin:10px;
    background-color:white;
    padding:5px 10px;
    border-radius:5px;
    min-height:35px;
    display:flex;
    align-items:center;
`

const Abs = styled.div`
    position:absolute;
`

const StyledBtn = styled.div`
    margin-right: 10px;
    font-size:24px;

    &:hover {
        color: red;
    }

    &:last-child {
        margin-right:0px;
    }
`

const ToolbarBtn = props => {
    const { icon, onClick, type, freehand } = props;
    return <StyledBtn data-freehand={freehand} data-type={type} className={icon} onClick={onClick} />
}

const DrawModeLabel = injectIntl(props => {
    const { label, intl, onClick } = props;
    return <div onClick={onClick}>{intl.formatMessage({ id: 'OLMap.InDrawMode' })}</div>
})

const DEBOUNCE_MS = 400

const Interaction = injectIntl(({ source, intl, save }) => {
    const { map } = useContext(MapContext)
    const [drawMode, setDrawMode] = useState(false)
    const [draw, setDraw] = useState(false)
    const debounceRef = useRef()




    //let draw;

    useEffect(() => {
        if (!map) return;

        const view = map.getView()

        const onAddFeature =  e => {
            save(map);
        }

        const onChange = e => {
            if(debounceRef.current) {
                clearTimeout(debounceRef.current)
            }
            debounceRef.current = setTimeout(() => void save(map), DEBOUNCE_MS)
        }

        source.on('addfeature', onAddFeature)
        view.on('change', onChange)

        return () => {
            try {
                if(debounceRef.current) {
                    clearTimeout(debounceRef.current)
                }

                save(map)
                
                source.off('addFeature', onAddFeature)
                view.off('change', onChange)

            } catch(err) {
                console.error(err)
            } 
        }

    }, [map, drawMode])


    /**
     * called when we want to draw on the map (interaction is the openlayer word for drawing)
     * 
     * Note: that we save the draw in state, as we need this to remove the interaction (see disableInteraction).
     * Note: Special case for remove, we create a select interaction and remove the feature using the 'add'-event.  
     */
    const enableInteraction = useCallback(e => {

        const type = get(e, 'currentTarget.dataset.type');
        const freehand = get(e, 'currentTarget.dataset.freehand');

        if (!map) return;

        let geometryFunction
        let _type

        switch (type) {
            case 'Point': {
                _type = type;
                break;
            }
            case 'Box': {
                geometryFunction = createBox();
                _type = 'Circle'
                break
            }
            case 'LineString': {
                _type = type;
                break;
            }
            case 'Remove' : {

                const selectSingleClick = new Select();
                selectSingleClick.getFeatures().on('add', function(feature){
                    source.removeFeature(feature.element);
                        feature.target.remove(feature.element);
                        save(map);

                });
                map.addInteraction(selectSingleClick);
                setDrawMode(type)
                setDraw(selectSingleClick)
                return
            }
        }

        const draw = new Draw({
            source,
            type: _type,
            freehand,
            geometryFunction
        });

        // draw.on('drawend', function(feature){
        //     save();
        // })

        map.addInteraction(draw);

        setDraw(draw)
        setDrawMode(type)
    }, [map, source])



    /**
     * Called once we stop drawing
     */
    const disableInteraction = useCallback(e => {
        map.removeInteraction(draw);
        setDrawMode(null)
        setDraw(null)
    }, [draw])

   

    return (
        <Abs>
            <ToolbarWrapper>
                {
                    drawMode && <DrawModeLabel onClick={disableInteraction} />
                }
                {
                    !drawMode && (
                        <>
                            <ToolbarBtn type='Point' icon='fal fa-dot-circle' onClick={enableInteraction} />
                            <ToolbarBtn type='Box' icon='fal fa-square' onClick={enableInteraction} />
                            <ToolbarBtn type='LineString' icon='fal fa-horizontal-rule' onClick={enableInteraction} />
                            <ToolbarBtn type='LineString' freehand={true} icon='fal fa-pen' onClick={enableInteraction} />
                            <ToolbarBtn type='Remove' freehand={true} icon='fal fa-eraser' onClick={enableInteraction} />
                        </>
                    )
                }

            </ToolbarWrapper>
        </Abs>
    )
})

export default Interaction;